import { CoinmarketcapImg } from "app/constants";

const CoinmarketcapIcon = () => {
  return (
    <img
      width="24"
      height="24"
      src={CoinmarketcapImg}
      alt="Coinmarketcap-icon"
    />
  );
};

export default CoinmarketcapIcon;
